import { encodeURIPath } from '@!/Util/string'

export const buildSearchUrl = (type, searchTerm, tabName) => {
  let url = `/store/search/${type}/${encodeURIPath(searchTerm)}`

  // カテゴリ検索の場合のみ、ジャンル名をパスに含める。
  if (type === 'category' && tabName && tabName !== 'home') {
    url += `/${tabName}`
  }

  return url
}
